import { map } from 'lodash';
import { errorCodes } from '../../../utils/errorCodes';
import { ENDPOINTS } from '../../../config/config';
import { REQUEST_TYPES } from '../requestTypes';
import { objectToSnakeCase } from '../../../utils/common';
import { type RequestHandlerFactory } from '../../types';

export const userRequests: Record<string, RequestHandlerFactory> = {
    [REQUEST_TYPES.REFRESH_TOKEN]: (params, data) => ({
        transformResponse: res => {
            return res.refresh.data;
        },
        descriptors: {
            refresh: {
                defaultEndpoint: ENDPOINTS.MANAGEMENT_CONSOLE_URL,
                method: 'post',
                url: '/v1/login/refresh',
                data: {
                    refresh_token: data.refreshToken
                },
                withAuth: false,
                transformData: [
                    objectToSnakeCase,
                    (payload: any) => {
                        const items = map(payload, (value, key) => [key, value]);
                        return new URLSearchParams(items as any).toString();
                    }
                ]
            }
        },
        errors: { default: errorCodes.auth.REFRESH_TOKEN_EXPIRED }
    }),
    [REQUEST_TYPES.LOGIN]: (params, data) => ({
        transformResponse: res => {
            return res.login.data;
        },
        descriptors: {
            login: {
                defaultEndpoint: ENDPOINTS.MANAGEMENT_CONSOLE_URL,
                method: 'post',
                url: '/v1/login',
                data: {
                    email: data.email,
                    password: data.password
                },
                withAuth: false,
                transformData: [
                    objectToSnakeCase,
                    (payload: any) => {
                        const items = map(payload, (value, key) => [key, value]);
                        return new URLSearchParams(items as any).toString();
                    }
                ]
            }
        },
        errors: { default: errorCodes.auth.LOGIN_FAILED }
    }),
    [REQUEST_TYPES.RECOVERY]: (params, data) => ({
        transformResponse: res => {
            return res.recovery.data;
        },
        descriptors: {
            recovery: {
                defaultEndpoint: ENDPOINTS.MANAGEMENT_CONSOLE_URL,
                method: 'post',
                url: '/v1/login/recovery',
                data: {
                    email: data.email
                },
                withAuth: false,
                transformData: [
                    objectToSnakeCase,
                    (payload: any) => {
                        const items = map(payload, (value, key) => [key, value]);
                        return new URLSearchParams(items as any).toString();
                    }
                ]
            }
        },
        errors: { default: errorCodes.auth.RECOVERY_FAILED }
    }),
    [REQUEST_TYPES.RECOVERY_RESET]: (params, data) => ({
        transformResponse: res => {
            return res.reset.data;
        },
        descriptors: {
            reset: {
                defaultEndpoint: ENDPOINTS.MANAGEMENT_CONSOLE_URL,
                method: 'post',
                url: '/v1/login/reset',
                data,
                withAuth: false,
                transformData: [
                    objectToSnakeCase,
                    (payload: any) => {
                        const items = map(payload, (value, key) => [key, value]);
                        return new URLSearchParams(items as any).toString();
                    }
                ]
            }
        },
        errors: { default: errorCodes.auth.RECOVERY_RESET_FAILED }
    }),
    [REQUEST_TYPES.FEEDBACK]: (params, data) => ({
        descriptors: {
            feedback: {
                defaultEndpoint: ENDPOINTS.MANAGEMENT_CONSOLE_URL,
                method: 'post',
                url: `/v1/users/me/feedback`,
                data: {
                    product: data.product,
                    scope: data.scope,
                    comment: data.comment,
                    call_id: String(data.callId), // TODO: remove this when the API is fixed
                    context: data.context
                },
                transformData: [objectToSnakeCase]
            }
        },
        errors: { default: errorCodes.user.FEEDBACK_FAILED }
    })
};
